import React from 'react';
import lodash from 'lodash';
import EbillService from '../../../service/EbillService';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import SearchBar from '../../searchbar/SearchBar';
import EbillCustomerDetails from './EbillCustomerDetails';
import './Ebill.css';

class EbillCustomerView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceOfferingId: 'gr_water',
    };
    this.comboFields = [
      {
        value: 'emailAddress',
        display: 'Email Address',
      },
      {
        value: 'externalAccountId',
        display: 'External Account ID',
      },
    ];
    this.serviceOfferings = [
      {
        value: 'gr_water',
        display: 'GR Water',
      },
      {
        value: 'shelby_tax',
        display: 'Shelby Tax',
      },
    ];
  }

  onServiceOfferingChange(event) {
    this.setState({
      serviceOfferingId: event.target.value,
    });
  }

  async onSearch({ search, combo, kill, }) {
    const { serviceOfferingId, } = this.state;
    const criteria = {
      serviceOfferingId,
    };
    criteria[combo.value] = search.value;
    this.reset();

    try {
      const { data, } = await EbillService.getEbillCustomers(criteria);
      const model = Grid.toModelFromList(data.ebillCustomers, {
        headerFormatter: value => lodash.startCase(value.header),
        filter: value => [
          'id',
          'customerId',
          'currentStatus',
          'emailAddress',
          'accountId',
          'externalAccountId',
          'ownerName',
          'address',
        ].includes(value),
      });
      this.setState({
        headers: model.headers,
        rows: model.format(data.ebillCustomers),
      });
    } catch (err) {
      console.log(err);
    } finally {
      kill();
    }
  }

  onRowSelect(selectedRow) {
    const { rows, } = this.state;
    const selectedEbillCustomer = rows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedCustomer: selectedEbillCustomer.raw,
    });
  }

  ebillFooter(selectedCustomer) {
    if (!selectedCustomer) {
      return null;
    }
    return (
      <div className="container">
        <p>{`Selected Enrollment: ${selectedCustomer.id}`}</p>
        <hr />
        <div className="row">
          <div className="m-1">
            <EbillCustomerDetails ebillCustomer={selectedCustomer} key={selectedCustomer.id} />
          </div>
        </div>
      </div>
    );
  }

  reset() {
    this.setState({
      headers: [],
      rows: [],
      selectedCustomer: null,
    });
  }

  renderSearchBar() {
    const { serviceOfferingId, } = this.state;
    return (
      <SearchBar
        comboFields={this.comboFields}
        onClick={event => this.onSearch(event)}
        serviceOfferingDropdown={
          <select
            className="form-select mt-2 me-2 ebill-service-offering-dropdown"
            value={serviceOfferingId}
            onChange={event => this.onServiceOfferingChange(event)}
          >
            {this.serviceOfferings.map(offering => (
              <option key={offering.value} value={offering.value}>
                {offering.display}
              </option>
            ))}
          </select>
        }
      />
    );
  }

  render() {
    const { rows, headers, selectedCustomer, } = this.state;
    return (
      <div className="container">
        <div className="alert alert-warning ebill-deprecation-warning" role="alert">
          <strong>Note:</strong> This eBilling feature is deprecated and may only be used for
          searching non-migrated service offerings that use the old eBilling system.
        </div>
        {this.renderSearchBar()}
        <div className="ebill-grid-container">
          <FieldSet title="Customers" style={{ maxHeight: '400px', }}>
            <Grid rows={rows} headers={headers} onRowSelect={row => this.onRowSelect(row)} />
          </FieldSet>
          {this.ebillFooter(selectedCustomer)}
        </div>
      </div>
    );
  }
}

export default EbillCustomerView;
